import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Checkbox } from 'antd';
import cs from 'classnames';

import { FormattedOption } from 'types/dictionaries';

import { UPGRADE_TIER_TOOLTIP } from 'constants/uiSettings';

import TooltipAccessWrapper from '../common/TooltipAccessWrapper';

interface CheckboxGroupProps {
  value: string[] | undefined;
  options: FormattedOption[];
  title?: string;
  disabled?: boolean;
  onChange?: (value: string[]) => void;
  isVertical?: boolean;
  hasAccessToFilter?: boolean;
}

const CheckboxGroup: FC<CheckboxGroupProps> = ({
  value,
  options,
  title,
  disabled = false,
  isVertical = true,
  onChange,
  hasAccessToFilter = false
}) => {
  const { t } = useTranslation();
  const handleChange = (value: string[]) => {
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <TooltipAccessWrapper
      hasAccessToFilter={hasAccessToFilter}
      message={t(UPGRADE_TIER_TOOLTIP)}
    >
      <div className="item-container">
        {title && (
          <div
            className={cs('item-title', {
              disabled: disabled || !hasAccessToFilter
            })}
          >
            {title}
          </div>
        )}
        <Checkbox.Group
          options={options}
          value={value}
          onChange={handleChange}
          className={cs({
            ['checkbox-group-vertical']: isVertical
          })}
          disabled={disabled || !hasAccessToFilter}
        />
      </div>
    </TooltipAccessWrapper>
  );
};

export default CheckboxGroup;
